const IconComponent = (name: string, properties?: any): JSX.Element => {
    const NewIconComponent: any = name;
    return <NewIconComponent style={properties} />
}


export default IconComponent;